export default __webpack_public_path__ + "static/typography-ga-greek-518abbc73a427d66c81359d9d283591c7d37e3da8b5a251289326c2c20901bbb.png";